import { z } from "zod";

// URL representation keeps relative filters relative when a saved link is reopened.
export const activityTimeSchema = z.string().refine((value) => {
  if (/^(within|older):[1-9]\d*:(days|weeks|months|years)$/.test(value)) {
    return Number.isSafeInteger(Number(value.split(":")[1]));
  }
  const [mode, date, extra] = value.split(":");
  return (
    extra === undefined &&
    (mode === "after" || mode === "before") &&
    z.iso.date().safeParse(date).success
  );
}, "Choose a positive duration or a valid before/after date.");

export function activityTimeLabel(value: string) {
  const [mode, amount, unit] = value.split(":");
  if (mode === "before" || mode === "after")
    return `${mode === "before" ? "Before" : "On or after"} ${amount}`;
  return `${mode === "older" ? "Older than" : "Last"} ${amount} ${amount === "1" ? unit?.slice(0, -1) : unit}`;
}
